import { render, staticRenderFns } from "./CardFraudulentContainer.vue?vue&type=template&id=1f56596a&scoped=true"
import script from "./CardFraudulentContainer.vue?vue&type=script&lang=js"
export * from "./CardFraudulentContainer.vue?vue&type=script&lang=js"
import style0 from "./CardFraudulentContainer.vue?vue&type=style&index=0&id=1f56596a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56596a",
  null
  
)

export default component.exports